/** 设置 cookie */
export function setCookie(
  name: string,
  value: string,
  maxAgeSeconds: number,
  path = "/"
) {
  const secure = location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAgeSeconds}; path=${path}; SameSite=Lax${secure}`;
}

/** 读取 cookie */
export function getCookie(name: string): string | undefined {
  const prefix = `${name}=`;
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const c = cookie.trim();
    if (c.startsWith(prefix)) {
      return decodeURIComponent(c.substring(prefix.length));
    }
  }
  return undefined;
}

/** 删除 cookie */
export function deleteCookie(name: string) {
  setCookie(name, "", -1);
}
